import React, { useLayoutEffect, useState } from "react";

import { Navigate, Outlet } from "react-router-dom";
import Footer from "../components/footer/Footer";
import UnAuthNav from "../components/nav/UnAuthNav";

// import { isUserLoggedIn } from "../services/auth/AuthAPI";

function UnAuthLayout(props: any) {
  return (
    <div className="app">
      <UnAuthNav />
      <Outlet />
      <Footer />
    </div>
  );
}

export default UnAuthLayout;
